import axios from '../../plugins/axios'


export const executionStore = {
    state: () => ({
        executions: [],
        execution: {},
    }),
    mutations: {
        setExecution(state, payload) {
            state.execution = payload;
        },
        setExecutions(state, payload) {
            state.executions = payload;
        },
    },
    actions: {
        GET_NODE_EXECUTION(_, id) {
            return axios.get('/node_execution/' + id + '/output', {
                headers: { "Authorization": localStorage.access_token },
            }).then(response => response.data.data);
        },
        GET_EXECUTION_NODES(_, executionId) {
            return axios.get('/execution/' + executionId + '/nodes', {
                headers: { "Authorization": localStorage.access_token },
            }).then(response => response.data.data);
        },
        GET_EXECUTIONS({commit}, filters) {
            return new Promise((resolve) => {
                const params = new URLSearchParams();
                params.append('page', filters.page || 1);
                if (filters.date_from) params.append('date_from', filters.date_from);
                if (filters.date_to) params.append('date_to', filters.date_to);
                const query = params.toString();
                const url = '/execution_by_workflow/' + filters.id + (query ? '?' + query : '');
                axios.get(url, {
                    headers: {
                        "Authorization": localStorage.access_token,
                    },
                })
                    .then(response => {
                        let values = response.data;
                        commit('setExecutions', values);
                        resolve(response);
                    })
                    .catch(error => error);
            });
        },
    },
    getters: {}
}

export default executionStore;